import type { RouteRecordRaw } from 'vue-router';
import { AppScreens } from '@/shared/types';

export const videoBibleRoute: RouteRecordRaw = {
  path: '/video-bible',
  name: AppScreens.VideoBible,
  meta: {
    layout: 'main',
  },
  component: () => import('@/modules/video-experience/views/VideoBible.vue'),
};
